import PropTypes from 'prop-types'

import theme from 'theme'

const CardList = ({ children, minWidth = 300 }) => (
  <div
    css={{
      display: 'grid',
      marginTop: theme.space[3],
      gap: theme.space[3],
      width: '100%',
      gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}px, 1fr))`
    }}
  >
    {children}
  </div>
)

CardList.propTypes = {
  children: PropTypes.node,
  minWidth: PropTypes.number
}

export default CardList
